export default {
  rewardsWelcomeMessage:
    "Добро пожаловать в Wellth, {0}! Мы хотим помочь вам заработать вознаграждение за то, что вы здоровы. Загрузите приложение Wellth на странице ",
  restfulWelcomeMessage:
    "Welcome to Restful, {0}! We want you to earn rewards for getting a great night's sleep. Download the Restful app to get started: ",
};
